import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a17b956"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notice-record" }
const _hoisted_2 = { class: "search-form" }
const _hoisted_3 = { class: "table-container" }
const _hoisted_4 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_5 = { key: 1 }

import { ref, watch,computed } from 'vue'
import {  ElButton, ElMessage, ElMessageBox } from "element-plus";
import tablist from './tablist.vue'
import { getListData } from '@/service/main/system'
import { ILoadingInstance } from 'element-plus/lib/el-loading/src/loading.type'
import { ElLoading } from 'element-plus'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import { useStore } from '@/store'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

dayjs.locale('zh-cn')

const store = useStore()
// 查询表单数据
const searchForm = ref({
  dateRange: [] // [开始日期, 结束日期]
})
const isEmp = computed(() => {
  const roles =store.state.login.userInfo.roles
  if(roles && roles.length > 0){
    return roles.find((role: any) => role.roleName === 'ROLE_EMP') ? true : false
  }else{
    return false
  }
});
const dynamicColumns = [
  { label: '前一日观看直播客户', key: 'name1' },
  { label: '30天内累计观看大于10天的客户', key: 'name3' },
  { label: '直播间定金订单客户信息', key: 'name6' },
  { label: '前一日未回复客户', key: 'name7' },
  { label: '前一日观看录播超过3分钟客户', key: 'name8' },
  { label: '近一周不允许拉群客户', key: 'name5' },
  { label: '新资源承接需联系列表', key: 'name2' },
  { label: '本月通话次数和时长统计', key: 'name9' },
  { label: '重复资源成交客户', key: 'name10' },
]


// 表格数据和加载状态
const tableData = ref<any[]>([])
let loadingInstance: ILoadingInstance = {} as ILoadingInstance

const pickDay = ref<Date | null>()
const handleFocus = () => {
  pickDay.value = null
}
// 禁用未来日期（只允许选当前选择的开始日期前后10天的日期）
const disabledDate = (time: Date) => {
  if (pickDay.value) {
    const  startTime = dayjs(pickDay.value.getTime()).subtract(9, 'day').valueOf()
    const  endTime  = dayjs(pickDay.value.getTime()).add(9, 'day').valueOf()
    return (
        time.getTime() < startTime||
        time.getTime() >  endTime ||
        time.getTime() > Date.now()
    )
  } else {
    return time.getTime() > Date.now()
  }
}
const handleChange = (val: Date[]) => {
  const [pointDay] = val
  pickDay.value = pointDay
}
/**
 * 核心：根据时间范围和分页参数生成新数据
 * @param {Array} dateRange - 时间范围 [startDate, endDate]
 */
const generateTableData = async (dateRange:any) => {
  if (document.querySelector('.table-container')) {
    if (loadingInstance && typeof loadingInstance.close == 'function') {
      loadingInstance.close()
    }
    loadingInstance = ElLoading.service({
      target: '.table-container',
      text: '加载中....',
      spinner: 'el-icon-loading',
      background: 'rgba(255, 255, 255, 0.8)',
      fullscreen: false
    })
  }
  try {
    let allData = [] as any
    if (dateRange && dateRange.length === 2) {
      const startDate = dayjs(dateRange[0])
      const endDate = dayjs(dateRange[1])

      // 校验时间范围合法性
      if (startDate.isAfter(endDate)) {
        ElMessage.error('开始日期不能晚于结束日期')
        tableData.value = []
        return
      }

      // 计算时间范围内的总天数
      const totalDays = endDate.diff(startDate, 'day') + 1
      let dateArr=[]
      // 生成当前页的数据：从结束日期（大日期）往开始日期（小日期）倒序生成
      // 遍历生成当前页数据
      for (let i = 0; i < totalDays; i++) {
        // 从结束日期往前推 i 天
        const currentDate = endDate.subtract(i, 'day')
        const dateStr = currentDate.format('YYYY-MM-DD')
        const dateCN = currentDate.format('YYYY年MM月DD日')
        if (!isEmp.value) {
          allData.push({
            date: dateStr,
            name: `${dateCN}通知提醒`,
            // 增加随机标识，证明每次生成的是新数据
            uniqueKey: Date.now() + Math.random()
          })
        } else {
          // 员工
          dateArr.push(dateStr)
        }
      }
      tableData.value = allData
      if(isEmp.value){
        let data =await getList(dateArr)
        allData =  Array.isArray(data) ? data : []
        tableData.value = allData
      }
    } else {
      if(isEmp.value){
        let data = await getList()
        allData =  Array.isArray(data) ? data : []
        tableData.value = allData
      }else{
        // 未选时间范围时：默认生成最近10天（从今天开始）的数据
        for (let i = 0; i < 10; i++) {
          const currentDate = dayjs().subtract(i , 'day') // 从昨天开始：i=0 → 昨天，i=1 → 前天...
          const dateStr = currentDate.format('YYYY-MM-DD')
          const dateCN = currentDate.format('YYYY年MM月DD日')
          allData.push({
            date: dateStr,
            name: `${dateCN}通知提醒`,
            uniqueKey: Date.now() + Math.random()
          })
        }
         tableData.value = allData
      }
    }
  } catch (error) {
    ElMessage.error('数据生成失败，请重试')
    tableData.value = []
  } finally {
     if (loadingInstance && typeof loadingInstance.close == 'function') {
        loadingInstance.close()
      }
  }
}
const getList = async (dateArr?:any) => {
  let params = {dateList:''}
  if(dateArr && dateArr.length>0){
    params ={dateList:dateArr.join(',')}
  }
  let allData=[] as any
  let list = await getListData('/main/notice-stats/getStats',params )
  if(list && list.length>0){
    let groupedObj={} as any
    list.forEach((element:any) => {
        const date = element.publishDate;
        // 如果当前日期还没有对应的数组，先初始化一个空数组
        if (!groupedObj[date]) {
          groupedObj[date] = [];
        }
        // 将当前元素添加到对应日期的数组中
        groupedObj[date].push(element);
    });
    // 3. 将对象的 value 提取出来，转换成最终的二维数组
    const result = Object.values(groupedObj);
    result.forEach((arr:any) => {
        let obj={date:arr[0].publishDate,uniqueKey: Date.now() + Math.random()} as any
        arr.forEach((element:any) => {
          obj['name'+element.noticeStyleType]= element.hasNotice == 1 && element.hasRead == 1 ? '已读' : element.hasNotice == 1 && element.hasRead == 0 ? '未读' : '无'
        });
        allData.push(obj)
    });
    console.log(allData)
  }
  return allData
}
// 查询按钮点击事件：重新生成数据
const onSearch = () => {
  generateTableData(searchForm.value.dateRange)
}

// 重置查询条件
const resetSearch = () => {
  searchForm.value.dateRange = []
  generateTableData([])
}
const tablistRef = ref<any>()
// 查看按钮点击事件
const handleView = (row:any) => {
  tablistRef.value.open(row)
}

// 页面初始化时生成默认数据
generateTableData([])

// 监听时间范围变化（可选：自动触发查询，也可保留手动查询）
// watch(() => searchForm.value.dateRange, () => {
//   if (searchForm.value.dateRange.length === 2) {
//     onSearch()
//   }
// }, { deep: true })

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_form, {
        inline: true,
        model: searchForm.value,
        class: "demo-form-inline"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { label: "时间范围：" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: searchForm.value.dateRange,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchForm.value.dateRange) = $event)),
                type: "daterange",
                "range-separator": "-",
                "start-placeholder": "开始日期",
                "end-placeholder": "结束日期",
                format: "YYYY-MM-DD",
                "value-format": "YYYY-MM-DD",
                "disabled-date": disabledDate,
                onCalendarChange: handleChange,
                onFocus: handleFocus
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_unref(ElButton), {
                type: "primary",
                onClick: onSearch
              }, {
                default: _withCtx(() => [
                  _createTextVNode("查询")
                ]),
                _: 1
              }),
              _createVNode(_unref(ElButton), { onClick: resetSearch }, {
                default: _withCtx(() => [
                  _createTextVNode("重置")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (!isEmp.value)
        ? (_openBlock(), _createBlock(_component_el_table, {
            key: 0,
            data: tableData.value,
            border: "",
            style: {"width":"100%"},
            height: "700"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "date",
                label: "日期",
                width: "130"
              }),
              _createVNode(_component_el_table_column, {
                prop: "name",
                label: "标题"
              }),
              _createVNode(_component_el_table_column, {
                label: "操作",
                width: "100"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_unref(ElButton), {
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (handleView(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("查看")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"]))
        : (_openBlock(), _createBlock(_component_el_table, {
            key: 1,
            data: tableData.value,
            border: "",
            style: {"width":"100%"},
            height: "700"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "date",
                label: "日期",
                width: "130"
              }),
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(dynamicColumns, (item) => {
                return _createVNode(_component_el_table_column, {
                  prop: item.key,
                  label: item.label,
                  "min-width": "100"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row[item.key] == '未读')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, "未读 "))
                      : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(scope.row[item.key]), 1))
                  ]),
                  _: 2
                }, 1032, ["prop", "label"])
              }), 64)),
              _createVNode(_component_el_table_column, {
                label: "操作",
                width: "100"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_unref(ElButton), {
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (handleView(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("查看")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"]))
    ]),
    _createVNode(tablist, {
      ref_key: "tablistRef",
      ref: tablistRef,
      onClose: onSearch
    }, null, 512)
  ]))
}
}

})